import { render, staticRenderFns } from "./FormNewBrief.vue?vue&type=template&id=60a01b31&scoped=true"
import script from "./FormNewBrief.vue?vue&type=script&lang=js"
export * from "./FormNewBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a01b31",
  null
  
)

export default component.exports